var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SchemaModule, ModuleValue } from './module';
import { DATE_DAY } from '../constants';
var ModuleValueGeneral = (function (_super) {
    __extends(ModuleValueGeneral, _super);
    function ModuleValueGeneral() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ModuleValueGeneral;
}(ModuleValue));
export { ModuleValueGeneral };
;
var SchemaModuleGeneral = (function (_super) {
    __extends(SchemaModuleGeneral, _super);
    function SchemaModuleGeneral() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._convertingWeight = false;
        _this._convertingHeight = false;
        _this._heightConversionTimeout = null;
        _this._weightConversionTimeout = null;
        _this._heightMetricConversionTimeout = null;
        _this._weightMetricConversionTimeout = null;
        return _this;
    }
    /**
     * Called when parent form has finished loading. Used to set up custom value listeners.
     * @param form Parent form component
     */
    SchemaModuleGeneral.prototype.hook = function (form) {
        _super.prototype.hook.call(this, form);
        this.listenValue('bmi_compute', this.fieldHandlerBMICompute.bind(this));
        this.listenValue(['body_weight', 'body_height'], this.fieldHandlerBMIWeightHeight.bind(this));
        // this.listenValue('bmi', this.fieldHandlerBMI.bind(this));
        // Imperial to Metric conversions
        this.listenValue('body_weight_imperial', this.fieldHandlerImperialWeightToMetric.bind(this));
        this.listenValue(['body_height_imperial_ft', 'body_height_imperial_in'], this.fieldHandlerImperialHeightToMetric.bind(this));
        // Metric to Imperial conversions
        this.listenValue('body_weight', this.fieldHandlerMetricWeightToImperial.bind(this));
        this.listenValue('body_height', this.fieldHandlerMetricHeightToImperial.bind(this));
    };
    SchemaModuleGeneral.prototype.fieldHandlerCopyValue = function (destinationProperty) {
        var _this = this;
        return function (value) {
            if (!_this.getValue(destinationProperty)) {
                _this.updateValue(destinationProperty, value);
            }
        };
    };
    SchemaModuleGeneral.prototype.fieldHandlerBMICompute = function (compute) {
        if (typeof compute === 'undefined' || compute === null || this.schema.properties.bmi_compute.readOnly) {
            return;
        }
        this.schema.properties['bmi'].readOnly = compute;
        this.schema.properties['body_weight'].readOnly = !compute;
        this.schema.properties['body_height'].readOnly = !compute;
        this.schema.properties['body_weight_imperial'].readOnly = !compute;
        this.schema.properties['body_height_imperial_ft'].readOnly = !compute;
        this.schema.properties['body_height_imperial_in'].readOnly = !compute;
        this.fieldHandlerBMIWeightHeight(this.getValue('body_weight'), this.getValue('body_height'));
    };
    SchemaModuleGeneral.prototype.fieldHandlerBMIWeightHeight = function (weight_kg, height_cm) {
        var real_weight_kg = this.getValue('body_weight');
        var real_height_cm = this.getValue('body_height');
        if (real_weight_kg === undefined || real_weight_kg === null
            || real_height_cm === undefined || real_height_cm === null) {
            return;
        }
        if (this.getValue('bmi_compute')) {
            this.calculateBMI(real_weight_kg, real_height_cm);
        }
    };
    // fieldHandlerBMI(bmi: number) {
    //   if (!this.getValue('bmi_compute')) {
    //     this.updateValue('body_weight', null);
    //     this.updateValue('body_height', null);
    //     this.updateValue('body_weight_imperial', null);
    //     this.updateValue('body_height_imperial_ft', null);
    //     this.updateValue('body_height_imperial_in', null);
    //   }
    // }
    SchemaModuleGeneral.prototype.fieldHandlerImperialWeightToMetric = function (weight_lbs) {
        var _this = this;
        if (weight_lbs === undefined || weight_lbs === null || this._convertingWeight || this.getValue('is_metric')) {
            return;
        }
        if (this._weightMetricConversionTimeout) {
            clearTimeout(this._weightMetricConversionTimeout);
        }
        // Debounce the conversion by 100ms to handle rapid typing
        this._weightMetricConversionTimeout = setTimeout(function () {
            _this._convertingWeight = true;
            if (weight_lbs && weight_lbs > 0) {
                var weight_kg = Math.round(weight_lbs / 2.20462 * 10) / 10; // Round to 1 decimal place
                if (_this.getValue('body_weight') !== weight_kg) {
                    _this.updateValue('body_weight', weight_kg);
                }
            }
            else if (_this.getValue('body_weight') !== null) {
                _this.updateValue('body_weight', null);
            }
            _this._convertingWeight = false;
        }, 300);
    };
    SchemaModuleGeneral.prototype.fieldHandlerImperialHeightToMetric = function (feet, inches) {
        var _this = this;
        if ((feet === undefined && inches === undefined)
            || (feet === null && inches === null)
            || this._convertingHeight || this.getValue('is_metric')) {
            return;
        }
        if (this._heightMetricConversionTimeout) {
            clearTimeout(this._heightMetricConversionTimeout);
        }
        // Debounce the conversion by 100ms to handle rapid typing
        this._heightMetricConversionTimeout = setTimeout(function () {
            _this._convertingHeight = true;
            // Only convert if we have complete valid data
            if ((feet !== null && feet >= 0) || (inches !== null && inches >= 0)) {
                var totalInches = (feet || 0) * 12 + (inches || 0);
                var height_cm = Math.round(totalInches * 2.54);
                if (_this.getValue('body_height') !== height_cm) {
                    _this.updateValue('body_height', height_cm);
                }
            }
            else if (feet === null && inches === null) {
                if (_this.getValue('body_height') !== null) {
                    _this.updateValue('body_height', null);
                }
            }
            _this._convertingHeight = false;
        }, 300);
    };
    SchemaModuleGeneral.prototype.fieldHandlerMetricWeightToImperial = function (weight_kg) {
        var _this = this;
        if (weight_kg === undefined || weight_kg === null || this._convertingWeight || !this.getValue('is_metric')) {
            return;
        }
        // Clear existing timeout to prevent multiple rapid conversions
        if (this._weightConversionTimeout) {
            clearTimeout(this._weightConversionTimeout);
        }
        // Debounce the conversion by 100ms to handle rapid typing
        this._weightConversionTimeout = setTimeout(function () {
            _this._convertingWeight = true;
            if (weight_kg && weight_kg > 0) {
                var weight_lbs = Math.round(weight_kg * 2.20462 * 10) / 10; // Round to 1 decimal place
                if (_this.getValue('body_weight_imperial') !== weight_lbs) {
                    _this.updateValue('body_weight_imperial', weight_lbs);
                }
            }
            else if (_this.getValue('body_weight_imperial') !== null) {
                _this.updateValue('body_weight_imperial', null);
            }
            _this._convertingWeight = false;
        }, 300);
    };
    SchemaModuleGeneral.prototype.fieldHandlerMetricHeightToImperial = function (height_cm) {
        var _this = this;
        if (height_cm === undefined || height_cm === null || this._convertingHeight || !this.getValue('is_metric')) {
            return;
        }
        // Clear existing timeout to prevent multiple rapid conversions
        if (this._heightConversionTimeout) {
            clearTimeout(this._heightConversionTimeout);
        }
        // Debounce the conversion by 100ms to handle rapid typing
        this._heightConversionTimeout = setTimeout(function () {
            _this._convertingHeight = true;
            if (height_cm !== null && height_cm > 0) {
                var totalInches = Math.round(height_cm / 2.54);
                var feet = Math.floor(totalInches / 12);
                var inches = totalInches % 12;
                if (_this.getValue('body_height_imperial_ft') !== feet || _this.getValue('body_height_imperial_in') !== inches) {
                    _this.updateValue('body_height_imperial_ft', feet);
                    _this.updateValue('body_height_imperial_in', inches);
                }
            }
            else if (height_cm === null || height_cm === 0) {
                if (_this.getValue('body_height_imperial_ft') !== null || _this.getValue('body_height_imperial_in') !== null) {
                    _this.updateValue('body_height_imperial_ft', null);
                    _this.updateValue('body_height_imperial_in', null);
                }
            }
            _this._convertingHeight = false;
        }, 300);
    };
    SchemaModuleGeneral.prototype.calculateBMI = function (weight_kg, height_cm) {
        var bmi = null;
        var height_m = height_cm / 100;
        var bmiSchema = this.getProperty('bmi').schema;
        // Clear previous message
        bmiSchema.description = '';
        if (weight_kg === null && height_cm === null) {
            // No values
        }
        else if (weight_kg === null || height_cm === null) {
            // Show info message about partial completion
            bmiSchema.description = this.generateMessage('%0 calculation requires both %1 and %2', 'bmi', 'body_weight', 'body_height');
        }
        else if (weight_kg > 0 && height_m > 0) {
            // Calculate the BMI
            bmi = Math.round(weight_kg / (Math.pow(height_m, 2)));
            if (isNaN(bmi) || !isFinite(bmi)) {
                bmi = null;
            }
            // Show out-of-range messages
            if (bmi < 18.5) {
                bmiSchema.description = 'Low';
            }
            else if (bmi > 30) {
                bmiSchema.description = 'Very high';
            }
            else if (bmi > 25) {
                bmiSchema.description = 'High';
            }
        }
        this.updateValue('bmi', bmi);
    };
    SchemaModuleGeneral.prototype.fieldHandlerDischargeDate = function (lengthOfStayProperty) {
        var _this = this;
        return function (dischargeDateString, dateOfSurgeryString) {
            var dateOfSurgery = new Date(dateOfSurgeryString);
            var dischargeDate = new Date(dischargeDateString);
            var lengthOfStay = Math.ceil((dischargeDate.valueOf() - dateOfSurgery.valueOf()) / DATE_DAY);
            if (isNaN(lengthOfStay.valueOf()) || lengthOfStay < 0) {
                lengthOfStay = null;
            }
            _this.updateValue(lengthOfStayProperty, lengthOfStay);
        };
    };
    return SchemaModuleGeneral;
}(SchemaModule));
export { SchemaModuleGeneral };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-general.ts.pre-build-optimizer.js